/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module DnsModule
 * @preferred
 */

import angular from 'angular';
import { initAjsDependency } from 'ajs/js/utilities/ajsDependency';

import {
    DNS_CLIENT_IP_MATCH_CONFIG_ITEM_TOKEN,
    DNS_CLIENT_PORT_MATCH_CONFIG_ITEM_TOKEN,
    DNS_GEO_LOCATION_MATCH_CONFIG_ITEM_TOKEN,
    DNS_INFO_CONFIG_ITEM_TOKEN,
    DNS_POLICY_COLLECTION_TOKEN,
    DNS_POLICY_ITEM_TOKEN,
    DNS_QUERY_NAME_MATCH_CONFIG_ITEM_TOKEN,
    DNS_QUERY_TYPE_MATCH_CONFIG_ITEM_TOKEN,
    DNS_RULE_ACTION_CONFIG_ITEM_TOKEN,
    DNS_RULE_CONFIG_ITEM_TOKEN,
    DNS_RULE_MATCH_TARGET_CONFIG_ITEM_TOKEN,
    DNS_TRANSPORT_PROTOCOL_MATCH_CONFIG_ITEM_TOKEN,
} from './dns.tokens';

import { DnsInfoConfigItem } from './factories/dns-info.config-item.factory';
import { DnsPolicyItem } from './factories/dns-policy.item.factory';
import { DnsRuleConfigItem } from './factories/dns-rule.config-item.factory';
import { DnsPolicyCollection } from './factories/dns-policy.collection.factory';
import { DnsRuleMatchTargetConfigItem }
    from './factories/dns-rule-match-target.config-item.factory';
import { DnsClientIpMatchConfigItem }
    from './factories/matches/dns-client-ip-match.config-item.factory';
import { DnsGeoLocationMatchConfigItem }
    from './factories/matches/dns-geo-location-match.config-item.factory';
import { DnsClientPortMatchConfigItem }
    from './factories/matches/dns-client-port-match.config-item.factory';
import { DnsTransportProtocolMatchConfigItem }
    from './factories/matches/dns-transport-protocol-match.config-item.factory';
import { DnsQueryNameMatchConfigItem }
    from './factories/matches/dns-query-name-match.config-item.factory';
import { DnsQueryTypeMatchConfigItem }
    from './factories/matches/dns-query-type-match.config-item.factory';
import { DnsRuleActionConfigItem }
    from './factories/dns-rule-action.config-item.factory';

const dnsModule = angular.module('avi/dns');
const factories = [
    {
        factory: DnsPolicyCollection,
        name: DNS_POLICY_COLLECTION_TOKEN,
    },
    {
        factory: DnsInfoConfigItem,
        name: DNS_INFO_CONFIG_ITEM_TOKEN,
    },
    {
        factory: DnsPolicyItem,
        name: DNS_POLICY_ITEM_TOKEN,
    },
    {
        factory: DnsRuleConfigItem,
        name: DNS_RULE_CONFIG_ITEM_TOKEN,
    },
    {
        factory: DnsRuleMatchTargetConfigItem,
        name: DNS_RULE_MATCH_TARGET_CONFIG_ITEM_TOKEN,
    },
    {
        factory: DnsClientIpMatchConfigItem,
        name: DNS_CLIENT_IP_MATCH_CONFIG_ITEM_TOKEN,
    },
    {
        factory: DnsClientPortMatchConfigItem,
        name: DNS_CLIENT_PORT_MATCH_CONFIG_ITEM_TOKEN,
    },
    {
        factory: DnsGeoLocationMatchConfigItem,
        name: DNS_GEO_LOCATION_MATCH_CONFIG_ITEM_TOKEN,
    },
    {
        factory: DnsTransportProtocolMatchConfigItem,
        name: DNS_TRANSPORT_PROTOCOL_MATCH_CONFIG_ITEM_TOKEN,
    },
    {
        factory: DnsQueryNameMatchConfigItem,
        name: DNS_QUERY_NAME_MATCH_CONFIG_ITEM_TOKEN,
    },
    {
        factory: DnsQueryTypeMatchConfigItem,
        name: DNS_QUERY_TYPE_MATCH_CONFIG_ITEM_TOKEN,
    },
    {
        factory: DnsRuleActionConfigItem,
        name: DNS_RULE_ACTION_CONFIG_ITEM_TOKEN,
    },
];

factories.forEach(({ name, factory }) => {
    initAjsDependency(dnsModule, 'factory', name, factory);
});
